{{ runChangeDetection }}
<!-- Avatar -->
<!--<div *ngIf="(arHistory[i-1] && arHistory[i-1].clientId != message.clientId) || !arHistory[i-1]"> -->
<ng-container *ngIf="(isAvatar && lvl == 1) || message?.from_user?.id === 'manager'">
  <app-avatar
    *ngIf="message.out; else inboxAvatar"
    [Service]="Service"
    [avatar]="message.avatar"
    [class.avatar-online]="message.online"
    [id]="message.from_user?.id"
    [type]="message?.from_user?.id === 'ai_bot' ? 'ai_bot' : 'private'"
    [avatarFileId]="message.avatar_file_id"
    [avatarFileUniqueId]="message?.avatar_file_unique_id"
    [force]="true"
    class="message-avatar avatar avatar-sm ml-4 ml-lg-5 d-none d-lg-block"
  ></app-avatar>
  <ng-template #inboxAvatar>
    <app-avatar
      (click)="openDetailInfo(message.from_user.id, message.from_user)"
      [Service]="Service"
      [class.avatar-online]="message.online"
      [id]="message.from_user?.id"
      [type]="Service.openChat?.type"
      [avatar]="message.avatar"
      [avatarFileId]="message.avatar_file_id"
      [avatarFileUniqueId]="message?.avatar_file_unique_id"
      class="message-avatar avatar avatar-sm mr-2 mr-lg-5 pointer"
    ></app-avatar>
  </ng-template>
</ng-container>

<!--</div>-->
<!-- Message: body -->
<div
  (click)="onClick($event)"
  [ngClass]="{
    effect: message.effect,
    'message-replay': type === 'reply',
    'message-manager': message?.from_user?.id === 'manager',
    'message-attachments':
      message?.attachments?.length > 0 ||
      (message.reply_to_messages && message.reply_to_messages[0]?.attachments?.length > 0),
    'message-out': message.out,
    'message-in': !message.out,
    'message-gift': message.gift,
    'message-delete': message.delete,
    'message-edit': message.edit_date,
    'message-reply-messages': message?.reply_to_messages?.length > 0,
    'message-text-long': message?.text?.length > 65,
    'message-views': message.views,
    active: message.select,
    showEffectUp: message.animate_add,
    deleted: message.deleted
  }"
  #messageWrap
  class="message-body message-smile-{{ getCountSmile(message?.text) }}"
>
  <!-- Message: row -->
  <div class="message-row">
    <div [class.justify-content-end]="message.out" class="d-flex align-items-center position-relative">
      <!-- Message: content -->
      <ng-template [ngIf]="!message.delete && !message.empty" [ngIfElse]="deleteMessageContent">
        <div class="toggleMessage" (click)="toggleMessage($event)"></div>
        <div
          *ngIf="!message.sticker && !message.voice; else messageNotContent"
          class="message-content"
          [style.background-color]="
            false && message.out && Service.openChat?.type === 'private' ? Service.openChat.color : ''
          "
        >
          <div #messageBody>
            <div (click)="contextMenuOpen.next({ event: $event, message: message })" class="btn-more pointer">
              <i-feather name="chevron-down" class="icon-lg"></i-feather>
            </div>
            <div class="message-checkbox">
              <div class="custom-control custom-checkbox">
                <input [checked]="message.select" class="custom-control-input" type="checkbox" />
                <label class="custom-control-label"></label>
              </div>
            </div>
            <h6 class="mb-2 font-weight-bold">
              <a
                (click)="openDetailInfo(message.from_user.id, message.from_user)"
                *ngIf="(!message.out || out || message?.from_user?.id === 'manager') && message?.name?.first; else elseTitles"
                [innerHTML]="message?.name?.first + ' ' + message?.name?.last | replaceEmojis: 'facebook':20:64"
                [ngStyle]="{
                  color: Service.openChat?.type !== 'private' ? message.color : ''
                }"
                class="pointer message-name"
              ></a>
              <ng-template #elseTitles>
                <a
                  (click)="openDetailInfo(message.forward_from.id, message.forward_from)"
                  *ngIf="message.forward_from"
                  class="pointer"
                >
                  Переслано от
                  <span
                    *ngIf="message?.forward_from?.name?.first"
                    [innerHTML]="
                      message.forward_from?.name?.first + ' ' + message.forward_from?.name?.last
                        | replaceEmojis: 'facebook':20:64
                    "
                    [ngStyle]="{ color: message.forward_from.color }"
                  ></span>
                </a>
                <a
                  (click)="openDetailInfo(message.forward_from_chat.id, message.forward_from_chat)"
                  *ngIf="message.forward_from_chat"
                  class="pointer"
                  >Переслано из
                  <span [innerHTML]="message.forward_from_chat.title | replaceEmojis: 'facebook':20:64"></span
                ></a>
              </ng-template>
            </h6>
            <!-- TODO обеспечить обновление сообщения вложенного -->
            <ng-template let-childMessage let-i="index" ngFor [ngForOf]="message?.reply_to_messages || []">
              <ng-template [ngIf]="!childMessage.compact" [ngIfElse]="fullMessage">
                <app-message
                  [Service]="Service"
                  [class.message-right]="childMessage.out"
                  [class.read]="childMessage.read"
                  [message]="childMessage"
                  [type]="childMessage.type || 'reply'"
                  [messagesContainer]="messagesContainer"
                  [lvl]="lvl"
                  [isAvatar]="isAvatar"
                  class="message mb-2"
                  id="message-{{ childMessage.id }}"
                ></app-message>
              </ng-template>
              <ng-template #fullMessage>
                <app-message-compact
                  [Service]="Service"
                  [class.message-right]="childMessage.out"
                  [class.read]="childMessage.read"
                  [message]="childMessage"
                  [type]="childMessage.type || 'reply'"
                  [lvl]="lvl"
                  class="message mb-2"
                  id="message-{{ childMessage.id }}"
                ></app-message-compact>
              </ng-template>
            </ng-template>
            <app-message-attachments
              [isAvatar]="isAvatar"
              [messagesContainer]="messagesContainer"
              [lvl]="lvl"
              [messageBody]="messageBody"
              *ngIf="message?.attachments?.length > 0 && !message.hidden"
              [Service]="Service"
              [message]="message"
              class="mt-2 d-block"
            ></app-message-attachments>
            <div *ngIf="message.empty" class="text-break text-muted">
              <i>Сообщение удалено</i>
            </div>
            <div
              *ngIf="message.text"
              [innerHTML]="message.text | href | replaceEmojis: 'facebook':24:64"
              class="text-break d-inline-block"
            ></div>
            <div *ngIf="type !== 'reply'" class="message-bottom mt-2 d-flex justify-content-between">
              <ng-template [ngTemplateOutlet]="date"></ng-template>
              <small *ngIf="message.edit_date && Service.openChat?.type !== 'channel'" class="editTime"
                >изменено {{ message.edit_date * 1000 | date: 'shortTime' }}</small
              >
              <div *ngIf="message.views" class="message-read ml-2">
                <span class="mr-4">{{ message.views }}</span>
                <i-feather name="eye"></i-feather>
              </div>
              <ng-template [ngTemplateOutlet]="read"></ng-template>
              <i-feather *ngIf="message.gift" placement="left" tooltip="Подарок" name="gift"></i-feather>
            </div>
            <div
              *ngFor="let line of message.keyboard || []"
              class="message-keyboard btn-group btn-group-justified mt-3"
            >
              <ng-template [ngForOf]="line || []" let-button let-c="count" let-i="index" ngFor>
                <button
                  (click)="clickKeyBoard(button)"
                  *ngIf="!button.url"
                  [innerHTML]="button.text | replaceEmojis: 'facebook':24:64"
                  class="btn btn-sm btn-white shadow"
                ></button>
                <a
                  (click)="onClick($event)"
                  *ngIf="button.url"
                  [attr.href]="button.url"
                  class="btn btn-sm btn-white shadow"
                  rel="noopener"
                  target="_blank"
                >
                  <span [innerHTML]="button.text | replaceEmojis: 'facebook':24:64"></span>
                  <i-feather class="text-muted" name="arrow-up-right"></i-feather>
                </a>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #deleteMessageContent>
        <div class="message-content">
          <div class="text-break message-deleted-text">
            <i>Данное сообщение удалено</i>
            <span tooltip="Подсмотреть" placement="left" class="text-warning" (click)="showDeleteMessage()"
              ><i-feather class="ml-2" name="eye"></i-feather
            ></span>
          </div>
        </div>
      </ng-template>

      <!-- Message: content -->
      <!-- Message: sticker -->
      <ng-template #messageNotContent>
        <div>
          <app-tgs-player
            *ngIf="message.sticker"
            [Service]="Service"
            [message]="message"
            [sticker]="message.sticker"
          ></app-tgs-player>
          <app-voice-player
            *ngIf="message.voice && !message.hidden"
            [Service]="Service"
            [message]="message"
            [voice]="message.voice"
          ></app-voice-player>
          <div
            *ngIf="type !== 'reply'"
            class="message-hover badge badge-lg badge-secondary rounded-lg shadow-sm mt-2 mx-auto d-block"
            [style.width]="'max-content'"
          >
            <ng-template [ngTemplateOutlet]="dateFull"></ng-template>
            <ng-template [ngTemplateOutlet]="read"></ng-template>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <!-- Message: row -->
</div>
<!-- Message: Body -->

<ng-template #date>
  <small class="message-date opacity-65 mr-2">{{ message.date | date: 'dd.M.yy' }}</small>
  <small class="message-time opacity-65 mr-2">{{ message.date | date: 'shortTime' }}</small>
</ng-template>
<ng-template #dateFull>
  <small class="message-full-date opacity-65 mr-2"
    >{{ message.date | date: 'shortTime' }} {{ message.date | date: 'd.MMM.yy' }}</small
  >
</ng-template>

<ng-template #read>
  <span *ngIf="message.out" class="message-read ml-2">
    <i-feather placement="top" tooltip="Прочитано" *ngIf="message.read" name="check"></i-feather>
    <i-feather name="check"></i-feather>
  </span>
</ng-template>
